import { CellProps } from "react-table";
import TextCell from "src/components/tables/cells/TextCell";
import { getFormattedDate } from "src/helpers/helpers";
import ActionsCell from "./ActionsCell";
import { WithdrawType } from "./withdraw-types";

const useExpensesTableColumns = ({
  onDelete,
}: {
  onDelete: (id: number) => void;
}) => {
  return [
    {
      Header: "Date",
      accessor: "date",
      className: "min-w-[150px]",
      Cell: ({ value }: CellProps<WithdrawType>) => (
        <TextCell value={getFormattedDate(value)} />
      ),
    },
    {
      Header: "Opening Amount",
      accessor: "opening",
      className: "min-w-[180px]",
      Cell: TextCell,
    },
    {
      Header: "Withdrawal",
      accessor: "withdraw",
      className: "min-w-[180px]",
      Cell: TextCell,
    },
    {
      Header: "Closing Amount",
      accessor: "closing",
      className: "min-w-[180px]",
      Cell: TextCell,
    },
    {
      Header: "Actions",
      accessor: "id",
      className: "min-w-[200px]",
      Cell: ({ value }: CellProps<WithdrawType>) => (
        <ActionsCell value={value} onDelete={() => onDelete(value)} />
      ),
    },
  ];
};

export default useExpensesTableColumns;
